import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { LocaleService } from '../../locale/locale.service';
import { Observable } from 'rxjs';
import { AddToCartPayload, CartItem } from "./cart.model";

const CART_COOKIE = 'NI_B2B_ORDER_ID';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private localeService: LocaleService
  ) {}

  addToCart(params: {
    url: string;
    partNumber: string;
    serviceAssociation: boolean;
  }): Observable<{ webCartId?: string }> {

    const payload = this.buildPayload(
      params.partNumber,
      params.serviceAssociation
    );

    return this.http.post<{ webCartId?: string }>(
      params.url,
      payload,
      { withCredentials: true }
    );
  }

  private buildPayload(partNumber: string, serviceAssociation: boolean): AddToCartPayload {
    const locale = this.localeService.getCurrentLocale();
    const webCartId = this.cookieService.get(CART_COOKIE) || '';

    const cartItem: CartItem = {
      partNumber,
      quantity: 1,
      childLineItems: []
    };

    if (serviceAssociation) {
      cartItem.duration = 1;
      cartItem.durationUom = 'YR';
    }

    return {
      webCartId,
      locale,
      cartItems: [cartItem]
    };
  }
}
